module.exports = __webpack_public_path__ + "static/media/screen-b10c03sha.66863191.png";